import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Star } from 'lucide-react';
import { shortTestimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  const hasSamples = shortTestimonials.some(testimonial => testimonial.isSample);
  return <section className="py-12 bg-surface border-y border-primary/10" data-id="element-287" data-mp="3nzlj2eeeqgfe">
      <div className="max-w-7xl mx-auto px-4" data-id="element-288" data-mp="3nyaewdh1v6nr">
        <div className="text-center mb-7" data-id="element-289" data-mp="5l2rapmoqir2">
          <p className="text-primary font-bold tracking-widest uppercase text-sm" data-id="element-290" data-mp="5jrddwzizum8">
            ⭐ What Automotive Technology Instructors Are Saying
          </p>
          {hasSamples && <p className="text-xs text-muted mt-2" data-id="element-291" data-mp="fj9v06ryr4b4">
              Replace these draft testimonial texts with verified customer reviews before publishing
              them as real customer testimonials.
            </p>}
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-292" data-mp="2cc1zavaroqi7">
          {shortTestimonials.map((testimonial, index) => <motion.article key={testimonial.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-primary/15 p-6 rounded-xl shadow-sm shadow-primary/5 flex flex-col" data-id="element-293" data-mp="cd90f9ilbrru" data-mpi={index}>
              <div className="flex items-center justify-between gap-3 mb-4" data-id="element-294" data-mp="v25kkkk9x3wc">
                <div className="flex gap-1 text-accent" aria-label="5 out of 5 stars" data-id="element-295" data-mp="101s7jlpwlyic">
                  {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={16} fill="currentColor" data-id="element-296" data-mp="144ojwuouoydu" data-mpi={starIndex} />)}
                </div>
                {testimonial.isSample && <span className="text-[10px] font-bold uppercase tracking-wider text-secondary bg-secondary/10 px-2 py-0.5 rounded-md whitespace-nowrap" data-id="element-297" data-mp="35w1ofimwp49d">
                    Draft Review
                  </span>}
              </div>
              <p className="text-body italic mb-6 text-sm leading-relaxed" data-id="element-298" data-mp="i1ywz5ydykxi">“{testimonial.text}”</p>
              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-primary/10" data-id="element-299" data-mp="d2upqkv0ux9t">
                <div className="w-10 h-10 rounded-lg bg-primary flex items-center justify-center text-accent font-bold text-sm shrink-0" aria-hidden="true" data-id="element-300" data-mp="qyg9acihkouu">
                  {getInitials(testimonial.name)}
                </div>
                <div className="min-w-0" data-id="element-301" data-mp="vz49noslui1q">
                  <div className="font-bold text-primary text-sm" data-id="element-302" data-mp="19r0wpeff21r9">{testimonial.name}</div>
                  <div className="text-xs text-secondary font-medium" data-id="element-303" data-mp="19svdcgjnn7pj">{testimonial.role}</div>
                  <div className="flex items-center gap-1 text-xs text-muted" data-id="element-304" data-mp="15rt9tnipg9hr">
                    <MapPin size={11} className="text-secondary shrink-0" data-id="element-305" data-mp="1jphscopav4jn" />
                    {testimonial.location}
                  </div>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}
function getInitials(name: string): string {
  return name.split(' ').map(part => part[0]).join('').slice(0, 2).toUpperCase();
}